export const Grain = () => <div className="grain" aria-hidden="true" />;
